// frontend/src/visitor_ai/context/VisitorAIContext.js
import React, { createContext, useContext, useState } from "react";

const VisitorAIContext = createContext();

export const VisitorAIProvider = ({ children }) => {
  const [messages, setMessages] = useState([]); 
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // new contextual states
  const [pendingAction, setPendingAction] = useState(null); // action_schema
  const [retrievalHint, setRetrievalHint] = useState(null);
  const [missingFields, setMissingFields] = useState(null);
  const [lastQuery, setLastQuery] = useState(null);

  const addMessage = (msg) => setMessages((prev) => [...prev, msg]);
  const resetConversation = () => {
    setMessages([]);
    setPendingAction(null);
    setRetrievalHint(null);
    setMissingFields(null);
  };

  return (
    <VisitorAIContext.Provider
      value={{
        messages,
        addMessage,
        isOpen,
        setIsOpen,
        loading,
        setLoading,
        pendingAction,
        setPendingAction,
        retrievalHint,
        setRetrievalHint,
        missingFields,
        setMissingFields,
        lastQuery,
        setLastQuery,
        resetConversation
      }}
    >
      {children}
    </VisitorAIContext.Provider>
  );
};

export const useVisitorAIContext = () => useContext(VisitorAIContext);
